import { Component } from '@angular/core';

@Component({
  selector: 'ui-input-addon',
  templateUrl: './input-addon.component.html'
})
export class InputAddonComponent {
}